import { Component } from 'react';
import axios from 'axios';
import styled from 'styled-components';

import customTagAPI from 'api/customTagAPI';

import Attachments from '../Attachments';
import CandidateHeaderSection from '../CandidateHeaderSection';
import Certification from './Certification';
import CustomTagSection from '../../CustomTag/CustomTagProfile/CustomTagSection';
import EmailModal from '../../EmailModal';
import OverviewSection from '../OverviewSection';
import PropTypes from 'prop-types';
import ScorecardModal from '../../ScorecardModal';
import StatusModal from '../../StatusModal';
import { PrintContainer } from 'features/PrintView/styles';
import { PrintDivider } from 'features/PrintView';

// end application confirmation page
import auth from 'utils/auth';
import { scorecardType } from 'utils/enums';
import { openUploadDocumentModal, submitAdditionalDocument } from 'utils/profileUtil';
import { openPrintDialogue } from '../../../utils/util';
import { validateTagUserType } from '../../CustomTag/util';
import { getATSCredentials } from 'utils/candidateUtils';

export default class Basics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailModalOpen: false,
      copyAppModalOpen: false,
      desiredStatus: {},
      statusModalOpen: false,
      districtTags: [],
      // if scorecard is passed in query params, open the profile page with the modal open
      scorecardModalOpen: props.scorecardParam !== null ? true : false,
      emailTemplate: {},
      subject: '',
      message: '',
      recipientList: [this.props.user],
      candidate_id: null,
      application_to_update: null,
      statusObj: {},
      archiveOtherApps: null,
      schoolappsToModify: null,
      helloSignTemplateModalOpen: false,
      /**** end status update section ****/
    };
    this.getUser = auth.getUser();
    this.openUploadDocumentModal = openUploadDocumentModal.bind(this);
    this.submitAdditionalDocument = submitAdditionalDocument.bind(this);
  }

  static propTypes = {
    user: PropTypes.object.isRequired,
    adminUsers: PropTypes.arrayOf(PropTypes.object).isRequired,
    sources: PropTypes.arrayOf(PropTypes.object).isRequired,
    emailTaggedUsers: PropTypes.func.isRequired,
    updateSchoolApp: PropTypes.func.isRequired,
    scorecardParam: PropTypes.number,
    editLocationQuery: PropTypes.func,
    scorecardSeen: PropTypes.bool,
    emailTemplatesList: PropTypes.array.isRequired,
    printBool: PropTypes.bool.isRequired,
    incrementScorecardCount: PropTypes.func.isRequired,
    newApplicationStatuses: PropTypes.array.isRequired,
    replaceCandidateInState: PropTypes.func.isRequired,
    updateCandidateInState: PropTypes.func.isRequired,
    fetchEvents: PropTypes.func,
    events: PropTypes.array.isRequired,
    fetchUser: PropTypes.func,
  };

  componentDidMount() {
    if (this.props.printBool) {
      this.props.removeLocationQuery('print');
      openPrintDialogue();
    }
    // check for new tags
    customTagAPI.fetchCustomTags().then((tags) => this.setState({ districtTags: tags }));
  }

  onSend = () => {
    if (this.state.schoolappsToModify) {
      this.handleSchoolAppUpdate();
    }
    return this.onHide();
  };

  handleSchoolAppUpdate = () => {
    // there are more school apps left to be updated, so update the school apps iteratively.
    // If we have multiple schoolapplications updated we have a different event logged on the
    // backend so we have to designate this for the server
    let multipleSchoolapplicationUpdate = false;
    if (this.state.schoolappsToModify.length > 1) {
      multipleSchoolapplicationUpdate = true;
    }
    this.state.schoolappsToModify.forEach((a, index) => {
      if (multipleSchoolapplicationUpdate && index === this.state.schoolappsToModify.length - 1) {
        multipleSchoolapplicationUpdate = this.state.schoolappsToModify.length;
      }
      this.props.updateSchoolApp({
        candidate_id: this.state.candidate_id,
        application_id: a.id,
        target_status: this.state.statusObj.id,
        archiveOtherApps: this.state.archiveOtherApps,
        multipleSchoolapplicationUpdate,
      });
    });
  };

  onHide = () => {
    this.setState({
      emailTemplate: {},
      subject: '',
      message: '',
      emailModalOpen: false,
      recipientList: [this.props.user],
      candidate_id: null,
      application_to_update: null,
      statusObj: {},
      archiveOtherApps: null,
      schoolappsToModify: null,
    });
  };

  viewScorecard = () => {
    this.setState({ scorecardModalOpen: true });
  };

  updateEmailTemplateSelection = (e) => {
    /** selected template will send up id as e.target.value. find in list */
    const emailTemplateProp = this.props.emailTemplatesList.find(
      (template) => template.id === Number(e.target.value)
    );

    if (emailTemplateProp) {
      let emailTemplate = Object.assign({}, emailTemplateProp);
      if (emailTemplate.content) {
        emailTemplate.content = emailTemplate.content.replace(/\n/g, '<br>');
      }
      this.setState({
        emailTemplate,
        subject: emailTemplate.subject,
        message: emailTemplate.content,
      });
    }
    if (e.target.value === null) {
      this.setState({
        emailTemplate: {},
        subject: '',
        message: '',
      });
    }
  };

  /**
   * Assigns selected tag to the specified candidate.
   */
  assignTag = async (tagId) => {
    const canidate = { ...this.props.user };
    // add tag to user
    await axios.post(`/api/candidate-tags/`, {
      tag: tagId,
      candidate: canidate.id,
    });
    this.props.fetchUser();
  };

  /**
   * Unassigns tag from the candidate/prospect
   */
  removeTag = async (tagId) => {
    await axios.delete(`/api/candidate-tags/${tagId}/`);
    this.props.fetchUser();
  };

  render() {
    const { user } = this.props;

    const skipEmailButton = (
      <button className="email-modal-button" onClick={this.onSend}>
        Skip Email
      </button>
    );

    const showDownloadButton =
      (user.profile.resume ||
        user.schoolapplication.district_application.applicationattachment_set.length > 0) &&
      user.schoolapplication.permissions.download_documents;

    const atsCredentials = getATSCredentials(user.credentials);

    return (
      <div className="flex-1 basics">
        <HeaderSection>
          <CandidateHeaderSection
            user={this.props.user}
            application={this.props.user.schoolapplication}
            schoolapplications={
              this.props.user.schoolapplication.district_application.schoolapplications
            }
            isDraft={false}
            openEmailModal={() => this.setState({ emailModalOpen: true })}
            openScorecardModal={() => this.setState({ scorecardModalOpen: true })}
            openCopyApplicationModal={() => this.setState({ copyAppModalOpen: true })}
            events={this.props.events}
            updateSchoolApp={this.props.updateSchoolApp}
            viewStatusModal={this.viewStatusModal}
            emailTemplatesList={this.props.emailTemplatesList}
            adminUsers={this.props.adminUsers}
            newApplicationStatuses={this.props.newApplicationStatuses}
            districtApplicationBeingViewedBySchoolAdmin={false}
            openPrintDialogue={openPrintDialogue}
          />
        </HeaderSection>

        <PrintContainer>
          <PrintDivider />
        </PrintContainer>

        <Section>
          <OverviewSection
            isDistrictAdmin={false}
            isDistrictUser={false}
            user={user}
            application={user.schoolapplication}
            schoolapplications={user.schoolapplication.district_application.schoolapplications}
            districtRole={user.schoolapplication.district_application.role}
            newApplicationStatuses={this.props.newApplicationStatuses}
            updateFullUser={this.props.updateCandidateInState}
            replaceCandidateInState={this.props.replaceCandidateInState}
            fetchEvents={this.props.fetchEvents}
            isDraft={false}
            candidateSources={this.props.sources}
          />
        </Section>

        {/*
          Spec: Hide section if district hasn't created any candidate tags.

          Spec: If there are no tags present in the district that the current
          user can view, the section should be hidden.
        */}
        {this.state.districtTags.length > 0 &&
          // check if current user_type can view any tags in district
          this.state.districtTags.some((tag) => validateTagUserType(auth.getUser(), tag)) && (
            <>
              <Section>
                <CustomTagSection
                  user={auth.getUser()}
                  fullUser={this.props.user}
                  assignTag={this.assignTag}
                  removeTag={this.removeTag}
                  districtTags={this.state.districtTags}
                  isFullProfile={true}
                />
              </Section>

              <PrintContainer>
                <PrintDivider />
              </PrintContainer>
            </>
          )}

        {this.state.emailModalOpen && (
          <EmailModal
            recipientList={this.state.recipientList}
            show={this.state.emailModalOpen}
            subject={this.state.subject}
            message={this.state.message}
            onHide={this.onHide}
            onSend={this.onSend}
            emailTemplatesList={this.props.emailTemplatesList}
            emailTemplate={this.state.emailTemplate}
            updateEmailTemplateSelection={this.updateEmailTemplateSelection}
            candidate={user}
            application={this.props.applicationBeingQuickviewed}
            showTemplates={true}
            footer={this.state.sendNotification ? skipEmailButton : null}
          />
        )}

        {this.state.scorecardModalOpen && (
          <ScorecardModal
            user={user}
            application={user.schoolapplication}
            show={this.state.scorecardModalOpen}
            onHide={() => this.setState({ scorecardModalOpen: false })}
            emailTaggedUsers={this.props.emailTaggedUsers}
            roleTitle={user.schoolapplication.role.title}
            scorecardParam={this.props.scorecardParam}
            removeLocationQuery={this.props.removeLocationQuery}
            scorecardSeen={this.props.scorecardSeen}
            incrementScorecardCount={this.props.incrementScorecardCount}
            scorecard_type={scorecardType.scorecard}
            adminUsers={this.props.adminUsers}
          />
        )}

        {this.state.statusModalOpen && (
          <StatusModal
            user={user}
            show={this.state.statusModalOpen}
            onHide={() => this.setState({ statusModalOpen: false })}
            schoolapplications={user.schoolapplication.district_application.schoolapplications}
            updateSchoolApp={this.props.updateSchoolApp}
            desiredStatus={this.state.desiredStatus}
            canUpdateStatus={this.isDistrictUser}
            updateUserStatus={this.props.updateUserStatus}
            applicationBeingQuickviewed={this.props.applicationBeingViewed}
          />
        )}

        <Section>
          <TwoColumnGridContainer>
            <div>
              <Attachments
                partialUser={user}
                fullUser={user}
                districtApplicationBeingQuickviewed={user.schoolapplication.district_application}
                openDocumentUploadModal={this.openUploadDocumentModal}
                openHellosignTemplateModal={() =>
                  this.setState({ helloSignTemplateModalOpen: true })
                }
                // the component expects a function so just return the boolean
                // from that function
                showDownloadIcon={() => showDownloadButton}
                isCandidateList
              />
              <PrintContainer>
                <PrintDivider />
              </PrintContainer>
            </div>

            <div>
              <Certification
                subjects={atsCredentials}
                hasNoCredentials={user.profile.has_no_credentials || user.credentials?.length === 0}
                isCandidateList
              />
              <PrintContainer>
                <PrintDivider />
              </PrintContainer>
            </div>
          </TwoColumnGridContainer>
        </Section>
      </div>
    );
  }
}

const Section = styled.div`
  padding: 26px;
  margin-bottom: 1rem;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.095);

  @media print {
    padding: 0;
  }
`;

const HeaderSection = styled(Section)`
  padding-bottom: 12px;

  @media print {
    padding: 0;
    margin: 0;
  }
`;

const TwoColumnGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 54px;

  @media print {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }
`;
